import BookingTimeSlot from '@/calendesk/models/BookingTimeSlot'
import parseTime from '@/calendesk/tools/parseTime'

export default function (spots: Array<any>, serviceMaxPeople: number) {
  const result: Array<BookingTimeSlot> = []
  spots.forEach((spot: any) => {
    const found = result.find((item) => item.time === spot.time)
    if (found) {
      found.used = found.used + spot.used
      found.max = found.max + serviceMaxPeople
    } else {
      result.push(new BookingTimeSlot(spot.time, serviceMaxPeople, spot.used))
    }
  })

  return [...result].sort((a, b) => {
    return parseTime(a.time) - parseTime(b.time)
  })
}
